import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import Router from "./Router";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { SnackbarProvider } from 'notistack';

import "./theme/App.scss";

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
    },
  },
});

class App extends React.Component {
  render() {
    // console.log("REACT_APP_SERVER_URL=", process.env.REACT_APP_SERVER_URL);
    // console.log("NODE_ENV=", process.env.NODE_ENV);
    // console.log("GCLOUD_PROJECT=", process.env.GCLOUD_PROJECT);
    // console.log("FIREBASE_TARGET=", process.env.FIREBASE_TARGET);
    // console.log("PUBLIC_URL=", process.env.PUBLIC_URL);
    // console.log("process.env", process.env);
    return (
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <SnackbarProvider>

            <Router />
          </SnackbarProvider>
        </Provider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    );
  }
}
export default App;
